/*
 * assets/vw-collection-popup.js
 * Collection popup voor VijverCheck cross-sell.
 *
 * Triggers via [data-vw-collection-popup="<handle>"][data-popup-title="..."]
 *
 * Fetch /collections/<handle>/products.json?limit=8 met 5min cache.
 * Add-to-cart via POST /cart/add.js, toast bij succes (reuse vw-toast-host
 * uit vijvercheck-save.js indien geladen).
 *
 * Geen em/en-dash. Mobile-first.
 */
(function () {
  'use strict';

  if (window.__vwCollectionPopupBooted) return;
  window.__vwCollectionPopupBooted = true;

  var ROOT_ID = 'vw-collection-popup';
  var CACHE_MS = 5 * 60 * 1000;
  var cache = Object.create(null); // handle -> { ts, products }
  var lastTrigger = null;
  var inflight = Object.create(null);

  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();

  function boot() {
    document.addEventListener('click', onClick, false);
    document.addEventListener('keydown', onKey, false);
    var root = getRoot();
    if (root) {
      var overlay = root.querySelector('[data-vw-popup-overlay]');
      var close = root.querySelector('[data-vw-popup-close]');
      if (overlay) overlay.addEventListener('click', closePopup);
      if (close) close.addEventListener('click', closePopup);
    }
  }

  function getRoot() { return document.getElementById(ROOT_ID); }

  function onClick(e) {
    var trg = e.target;
    while (trg && trg !== document.body) {
      if (trg.nodeType === 1 && trg.hasAttribute && trg.hasAttribute('data-vw-collection-popup')) {
        e.preventDefault();
        var handle = trg.getAttribute('data-vw-collection-popup');
        var title = trg.getAttribute('data-popup-title') || 'Collectie';
        lastTrigger = trg;
        openPopup(handle, title);
        return;
      }
      // Add-to-cart binnen popup
      if (trg.nodeType === 1 && trg.hasAttribute && trg.hasAttribute('data-vw-popup-add')) {
        e.preventDefault();
        var vid = trg.getAttribute('data-variant-id');
        if (vid) addToCart(vid, trg);
        return;
      }
      trg = trg.parentNode;
    }
  }

  function onKey(e) {
    if (e.key !== 'Escape') return;
    var root = getRoot();
    if (root && root.style.display === 'block') closePopup();
  }

  function openPopup(handle, title) {
    var root = getRoot();
    if (!root) {
      // Snippet niet gerendered, fallback naar nieuw tabblad
      window.open('/collections/' + encodeURIComponent(handle), '_blank', 'noopener');
      return;
    }
    setText(root, '[data-vw-popup-title]', title);
    var allLink = root.querySelector('[data-vw-popup-all-link]');
    var errLink = root.querySelector('[data-vw-popup-error-link]');
    var url = '/collections/' + encodeURIComponent(handle);
    if (allLink) allLink.setAttribute('href', url);
    if (errLink) errLink.setAttribute('href', url);

    showState(root, 'skeleton');
    root.style.display = 'block';
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // CSS handelt open-state via [aria-hidden="false"], geen inline transform meer
    // (anders breekt mobile drawer-slide vanaf onder, audit 2026-05-27)

    // Focus close-button
    var close = root.querySelector('[data-vw-popup-close]');
    if (close) setTimeout(function () { try { close.focus(); } catch (_) {} }, 60);

    loadCollection(handle).then(function (products) {
      if (root.style.display !== 'block') return;
      if (!products || !products.length) {
        // Geen items -> open in nieuw tabblad
        showState(root, 'error');
        return;
      }
      renderGrid(root, products, handle, title);
      showState(root, 'grid');
    }).catch(function () {
      showState(root, 'error');
    });
  }

  function closePopup() {
    var root = getRoot();
    if (!root) return;
    // Set aria-hidden first zodat CSS-transition uitspeelt, dan display:none
    root.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      root.style.display = 'none';
      document.body.style.overflow = '';
      if (lastTrigger) {
        try { lastTrigger.focus(); } catch (_) {}
      }
    }, 250);
  }

  function showState(root, state) {
    var skel = root.querySelector('[data-vw-popup-skeleton]');
    var err = root.querySelector('[data-vw-popup-error]');
    var grid = root.querySelector('[data-vw-popup-grid]');
    var footer = root.querySelector('[data-vw-popup-footer]');
    if (skel) skel.style.display = state === 'skeleton' ? 'grid' : 'none';
    if (err) err.style.display = state === 'error' ? 'block' : 'none';
    if (grid) grid.style.display = state === 'grid' ? 'grid' : 'none';
    if (footer) footer.style.display = state === 'grid' ? 'block' : 'none';
  }

  function loadCollection(handle) {
    var hit = cache[handle];
    var now = Date.now();
    if (hit && (now - hit.ts) < CACHE_MS) {
      return Promise.resolve(hit.products);
    }
    if (inflight[handle]) return inflight[handle];

    var p = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=8', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      var prods = (data && data.products) || [];
      cache[handle] = { ts: Date.now(), products: prods };
      delete inflight[handle];
      return prods;
    }).catch(function (e) {
      delete inflight[handle];
      throw e;
    });

    inflight[handle] = p;
    return p;
  }

  function renderGrid(root, products, handle, title) {
    var grid = root.querySelector('[data-vw-popup-grid]');
    if (!grid) return;
    grid.innerHTML = '';

    products.slice(0, 8).forEach(function (p) {
      var firstVar = (p.variants && p.variants[0]) || null;
      var img = (p.images && p.images[0] && p.images[0].src) ||
                (firstVar && firstVar.featured_image && firstVar.featured_image.src) || '';
      var price = firstVar ? formatPrice(firstVar.price) : '';
      var available = firstVar ? firstVar.available : false;
      var purl = '/products/' + p.handle;

      var card = document.createElement('div');
      card.style.cssText = 'display:flex;flex-direction:column;background:#fff;border:1px solid #e2e8f0;border-radius:14px;overflow:hidden;';

      var imgHtml = img
        ? '<a href="' + purl + '" target="_blank" rel="noopener" style="display:block;aspect-ratio:1/1;background:#f8fafc;overflow:hidden;">' +
          '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">' +
          '</a>'
        : '<a href="' + purl + '" target="_blank" rel="noopener" style="display:block;aspect-ratio:1/1;background:#f8fafc;"></a>';

      var btnHtml;
      if (firstVar && available) {
        btnHtml = '<button type="button" data-vw-popup-add data-variant-id="' + esc(firstVar.id) + '" ' +
                  'style="margin-top:auto;background:#F26A4B;color:#fff;border:none;border-radius:10px;padding:10px 12px;font-weight:600;font-size:.875rem;cursor:pointer;min-height:40px;">' +
                  'In winkelmand</button>';
      } else if (firstVar) {
        btnHtml = '<a href="' + purl + '" target="_blank" rel="noopener" ' +
                  'style="margin-top:auto;display:inline-flex;align-items:center;justify-content:center;background:#0B1E36;color:#fff;border-radius:10px;padding:10px 12px;font-weight:600;font-size:.875rem;text-decoration:none;min-height:40px;">' +
                  'Bekijk product</a>';
      } else {
        btnHtml = '<a href="' + purl + '" target="_blank" rel="noopener" ' +
                  'style="margin-top:auto;display:inline-flex;align-items:center;justify-content:center;background:#0B1E36;color:#fff;border-radius:10px;padding:10px 12px;font-weight:600;font-size:.875rem;text-decoration:none;min-height:40px;">' +
                  'Bekijk product</a>';
      }

      card.innerHTML =
        imgHtml +
        '<div style="padding:10px 12px 12px;display:flex;flex-direction:column;gap:6px;flex:1;">' +
        '<a href="' + purl + '" target="_blank" rel="noopener" style="font-size:.8125rem;font-weight:600;color:#0B1E36;line-height:1.3;text-decoration:none;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.6em;">' +
        esc(p.title) +
        '</a>' +
        (price ? '<div style="font-size:.9375rem;font-weight:700;color:#0F766E;">' + esc(price) + '</div>' : '') +
        (available ? '' : '<div style="font-size:.75rem;color:#7f1d1d;font-weight:600;">Tijdelijk uitverkocht</div>') +
        btnHtml +
        '</div>';

      grid.appendChild(card);
    });

    var label = root.querySelector('[data-vw-popup-all-label]');
    if (label) {
      var n = products.length;
      label.textContent = 'Bekijk alle ' + n + (n === 1 ? ' product' : ' producten') + ' in deze collectie';
    }
  }

  function addToCart(variantId, btn) {
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Bezig...';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    }).then(function () {
      btn.textContent = 'Toegevoegd';
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 1800);
      showToast('Toegevoegd aan winkelmand', 'ok');
      bumpCartCount(1);
    }).catch(function () {
      btn.textContent = orig;
      btn.disabled = false;
      showToast('Toevoegen mislukt, probeer opnieuw.', 'err');
    });
  }

  function bumpCartCount(n) {
    try {
      var nodes = document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count');
      nodes.forEach(function (el) {
        var cur = parseInt(el.textContent, 10);
        if (!isNaN(cur)) el.textContent = String(cur + n);
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (_) {}
  }

  function showToast(msg, kind) {
    // Reuse host uit vijvercheck-save.js indien aanwezig, anders kleine eigen
    var host = document.getElementById('vw-toast-host');
    if (!host) {
      host = document.createElement('div');
      host.id = 'vw-toast-host';
      host.setAttribute('aria-live', 'polite');
      host.setAttribute('aria-atomic', 'true');
      host.style.cssText = 'position:fixed;z-index:300;bottom:16px;right:16px;display:flex;flex-direction:column;gap:8px;pointer-events:none;max-width:360px;';
      document.body.appendChild(host);
    }
    var el = document.createElement('div');
    el.className = 'vw-toast vw-toast--' + (kind === 'err' ? 'err' : 'ok');
    el.style.cssText = 'pointer-events:auto;background:' + (kind === 'err' ? '#7f1d1d' : '#0B1E36') +
      ';color:#fff;padding:12px 14px;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,.18);font-size:14px;';
    el.textContent = msg;
    host.appendChild(el);
    setTimeout(function () { try { el.remove(); } catch (_) {} }, 3200);
  }

  function setText(root, sel, txt) {
    var el = root.querySelector(sel);
    if (el) el.textContent = txt;
  }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function formatPrice(cents) {
    // Shopify products.json geeft prijs als string in shop currency-eenheden (bv "12.95")
    // of als integer (oudere endpoint). Probeer beide.
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    // Heuristiek: > 1000 zonder decimaalpunt zou centen kunnen zijn
    if (n >= 1000 && String(cents).indexOf('.') === -1) n = n / 100;
    return 'EUR ' + n.toFixed(2).replace('.', ',');
  }
})();
